import * as React from 'react';
import {WithStyles, withStyles,} from '@material-ui/core';
import TranslateNew from '@translate/TranslateNew';
import { VVTimePickerStyle } from './timepicker.style';
import { styleColors } from 'src/main.style';
import { ILocalEvent } from '@app-types/websocket/event.types';
import { addDays } from '@helpers/DateHelper';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  dateDelta:number;
  startDate:Date;
}

interface IProps extends WithStyles<typeof VVTimePickerStyle> {
  open:boolean;
  date:Date;
  setDate:(date:Date) => void;
}

class VVDatePicker extends React.Component<IProps, IState> {
  private touchStartY = 0;
  private touchStartTop = 0;
  private scrollDateRef: React.RefObject<HTMLDivElement> = React.createRef();

  private scrollDateRefValues: Array<React.RefObject<HTMLDivElement>> = [
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),
    React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),React.createRef(),];

  constructor(props: IProps) {
    super(props);

    this.state = {
      dateDelta:0,
      startDate:new Date(props.date)
    }
  }
  public componentDidMount() {
    if (this.scrollDateRef.current) {
      this.scrollDateRef.current.scrollTop = 34*(10);
    }
  }

  public componentDidUpdate(prevProps:IProps) {
    if (this.props.open !== prevProps.open) {
      if (this.scrollDateRef.current) {
        this.scrollDateRef.current.scrollTop = 34*(10);
      }
      this.setState({dateDelta:0,startDate:new Date(this.props.date)});
    }
  }


  public renderOptions(nomOption:number) {
    const elements:JSX.Element[] = [];
    for (let index = 0; index < nomOption; index++) {
      elements.push(<div className={this.props.classes.scrollOption+" "+this.props.classes.dateScrollOption} key={index} 
        onClick={(e) => e.currentTarget.scrollIntoView({behavior:"smooth", block:"center"})}/>)
    }
    return elements;
  }

  public renderValues(nomOption:number) {
    const elements:JSX.Element[] = [];
    for (let index = 0; index < nomOption; index++) {
      const optionDate = addDays(this.state.startDate, 37-index);
      elements.push(<div className={this.props.classes.option+" "+this.props.classes.dateOption}  style={{fontSize:'16px'}}
        ref={this.scrollDateRefValues[index]}  key={index} >
          {tn.formatDateShort(optionDate)}
        </div>)
    }
    return elements;
  }

  public render() {
    const {classes, open} = this.props;

    return (
      <div className={classes.timePicker} style={{maxHeight:(open?170:0),minHeight:(open?170:0)}}>
      <div className={classes.timepickerViewport} style={{maxWidth:230, width:230}}>
        <div className={classes.scrollPane} style={{maxWidth:230, width:230}} onScroll={this.handleScrollDate}
          // onTouchStartCapture={this.onTouchStart} // fallback pan
          // onTouchMoveCapture={this.onTouchMove}   // fallback pan
          ref={this.scrollDateRef}>
          {this.renderOptions(48)}
        </div>
        <div className={classes.wheelMarker} style={{width: '250px', padding:0}} />
        <div className={classes.wheel} style={{maxWidth:230, width:230}}>
          {this.renderValues(48)}
        </div>
      </div>
      </div>
    );
  }

  // Fallback pan handlers
  private onTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    const el = this.scrollDateRef.current;
    if (!el) return;
    this.touchStartY = e.touches[0].clientY;
    this.touchStartTop = el.scrollTop;
  };

  private onTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    const el = this.scrollDateRef.current;
    if (!el) return;

    const dy = e.touches[0].clientY - this.touchStartY;
    const prev = el.scrollTop;
    el.scrollTop = this.touchStartTop - dy;

    // If we actually scrolled the inner element, keep the gesture here.
    if (el.scrollTop !== prev) {
      e.stopPropagation();  // don’t let body/page handlers hijack it
      e.preventDefault();   // prevent page scroll while we pan the inner scroller
    }
  };

  private handleScrollDate = () =>  {
    const {date, setDate} = this.props;
    const {dateDelta} = this.state;

    const container = this.scrollDateRef.current;
    if (container) {
      const scrollDegrees = ((container.scrollTop*30) / 34);
      const stepsScrolledDown = (Math.round(container.scrollTop / 34))

      if (dateDelta !== stepsScrolledDown-10) {
        this.setState({dateDelta:(stepsScrolledDown-10)});
        const newDate =  addDays(this.state.startDate, (stepsScrolledDown-10));
        setDate(newDate);
      }
      
      const selectedIndex = 48 - stepsScrolledDown;
      
      let i = 0;
      for (const ref of this.scrollDateRefValues) {
        if (ref.current) {

          // Calculate the direct distance
          const distance = Math.abs(i - selectedIndex);

          if (distance <= 3) {
            ref.current.style.transform = `rotateX(${(30 * (i+1))+scrollDegrees}deg) translateZ(70px)`;
            ref.current.style.color = (selectedIndex === (i+1))?styleColors.black:'#bbbbbb';  
            ref.current.style.opacity = "1";
          } else {
            ref.current.style.opacity = "0";
          }
        }
        i++;
      }
    }
  }

}

export default withStyles(VVTimePickerStyle)(VVDatePicker);



// WEBPACK FOOTER //
// ./src/components/common/timepicker/VVDatePicker.tsx